import { registerMockAPI } from '~/mocks/mockApis';

import dayjs from 'dayjs';

import { axiosInstance } from '~/services';

import { RECEIVE } from '~/constants/errorCode';

import type {
  TypeApiResponse,
  TypeGetInboundAreaOperationDatesParams,
  TypeGetInboundAreaOperationDatesResponse,
} from '~/types/receive.types';

/**
 * [입고요청관리] 입고(예약)가능일자 목록 조회 API
 */
export const fetchInboundAreaOperationDates = async (
  params: TypeGetInboundAreaOperationDatesParams
): Promise<TypeGetInboundAreaOperationDatesResponse> => {
  const { data } = await axiosInstance.get<TypeApiResponse<TypeGetInboundAreaOperationDatesResponse>>(
    '/api-inbound/v1/3pl/inbound-area/operation-dates',
    { params }
  );
  return data.data;
};

const buildOperationDatesResponse = (count: number): TypeApiResponse<TypeGetInboundAreaOperationDatesResponse> => {
  const dates = Array.from({ length: count }, (_, i) => dayjs().add(i, 'day').format('YYYY-MM-DD'));
  return { data: { orderId: 1001, dates } };
};

registerMockAPI<TypeApiResponse<TypeGetInboundAreaOperationDatesResponse>>({
  method: 'get',
  endpoint: '/api-inbound/v1/3pl/inbound-area/operation-dates',
  label: '입고/입고요청/운영일자',
  scenarios: [
    { name: '정상 응답 — 5일치', response: () => buildOperationDatesResponse(5) },
    { name: '정상 응답 — 빈 배열', response: () => buildOperationDatesResponse(0) },
    {
      name: '입고일시 없음 (9030)',
      response: {
        error: {
          code: RECEIVE.RECEIVE_DATE_TIME_NOT_EXIST,
          message: '운영 가능 일자가 없습니다.',
        },
      },
      status: 400,
    },
  ],
});
